import React, { useState } from "react";
import avatarIcon from "../../../assets/icons/avatar.svg";
import admIcon from "../../../assets/icons/adm_icon.svg";
import backIcon from "../../../assets/icons/back_icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useUser, UserRole } from "../../../services/UserContext";
import CustomAlert from "../../CustomAlert";
import Popup from "../../utils/popups/Popup";

const Header = () => {
  const [isLogoutConfirmed, setLogoutConfirmed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // sets kids value on url change, only happens when
  // url includes skill and age=1
  if (window.location.href.includes("skill")) {
    if (window.location.href.includes("age=1"))
      localStorage.setItem("kids", "true");
    else localStorage.setItem("kids", "false");
  }

  const userSelectedKids = () => {
    return localStorage.getItem("kids") === "true";
  };

  const navigate = useNavigate();
  const { role } = useUser(); // Use role instead of userData

  const togglePopup = () => setIsOpen(!isOpen);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {isLogoutConfirmed && role === UserRole.USER && (
        <CustomAlert
          message="Logout erfolgreich"
          type="success"
          duration={2000}
        />
      )}
      {role !== UserRole.USER && (
        <CustomAlert
          message="Login erfolgreich"
          type="success"
          duration={2000}
        />
      )}

      <header className="header">
        <div className="header__container">
          {window.location.pathname !== "/" &&
            !window.location.pathname.startsWith("/skill") && (
              <img
                src={backIcon}
                draggable={false}
                alt="Back Icon"
                onClick={handleGoBack}
                className="header__icon-left"
              />
            )}

          <Link
            to="/"
            className="header__logo"
            onDragStart={(e) => e.preventDefault()}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            snowledge
            {userSelectedKids() && <p className="header__logo__kids">kids</p>}
          </Link>
          {role === UserRole.USER ? (
            <Link to="/login" className="header__logo"
              onDragStart={(e) => e.preventDefault()}>
              <img
                src={admIcon}
                alt="Admin Icon"
                className="header__icon-right"
              />
            </Link>
          ) : (
            <div
              className="avatar-container"
              onClick={togglePopup}
              onDragStart={(e) => e.preventDefault()}
            >
              {/* Avatar */}
              <img
                id="popup"
                src={avatarIcon}
                draggable={false}
                alt="Avatar Icon"
                className="avatar__icon"
              />

              {/* Popup */}
              {isOpen && <Popup setLogoutConfirmed={setLogoutConfirmed} />}
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
